module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('debug-stats', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.debugSettings.statsEnabled),
      expression: "debugSettings.statsEnabled"
    }],
    ref: "debugStats",
    attrs: {
      "hls": _vm.hls
    }
  }), _vm._v(" "), _c('debug-metrics', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.debugSettings.metricsEnabled),
      expression: "debugSettings.metricsEnabled"
    }],
    ref: "debugMetrics",
    attrs: {
      "hls": _vm.hls
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8473e6de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Debug/Debug.vue
// module id = 95
// module chunks = 0